import { InputAdornment, TextField } from '@mui/material';
import { TextBlock } from '../../../Atoms/Text';
import { dollars } from './currentSupplierSpend';

export interface MonthlyTotalFieldProps {
  total: string;
  canEdit: boolean;
  error: string | null;
  disabled: boolean;
  onChange: (text: string) => void;
}

/** A supplier's spend as one monthly amount, counted as in-scope Other spend. */
export const MonthlyTotalField = ({ total, canEdit, error, disabled, onChange }: MonthlyTotalFieldProps) => {
  if (!canEdit) {
    return (
      <TextBlock
        size="sm14"
        color="grey8">
        {`Monthly total: ${total ? dollars(Number(total)) : '—'}`}
      </TextBlock>
    );
  }
  return (
    <TextField
      size="small"
      className="max-w-xs"
      label="Monthly total"
      value={total}
      disabled={disabled}
      placeholder="0.00"
      error={!!error}
      helperText={error ?? 'Counted as in-scope Other spend.'}
      InputLabelProps={{ shrink: true }}
      inputProps={{ inputMode: 'decimal' }}
      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
      onChange={(event) => onChange(event.target.value)}
    />
  );
};
